import React from 'react';
import clsx from 'clsx';

import { Caption } from '@edx/components/typography';

type Props = {
  background?: keyof typeof Background;
  className?: string;
};

enum Background {
  default = 'bg-primary-500',
  dark = 'bg-gray-800',
}

export const Badge: React.FC<Props> = ({ background = 'default', className, children }) => (
  <Caption
    tag="span"
    size="small"
    variant="semibold"
    className={clsx('text-white px-1 py-0.5 rounded text-white', Background[background], className)}
  >
    {children}
  </Caption>
);
